import styled from 'styled-components';

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 32px 24px;

  height: calc(100vh - 90px);

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    height: calc(100vh - 100px);
  }

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    width: 802px;
    margin: 0 auto;
    height: calc(100vh - 184px);
  }
`;
